<template>
  <v-dialog
    v-model="isOpen"
    width="600"
    scrollable
    @click:outside="close"
    content-class="rounded-lg"
    :persistent="loading"
  >
    <v-card :loading="loading">
      <v-card-title class="pt-3">
        <div class="d-flex align-center gap-2">
          <v-img
            v-if="session?.Device?.Model?.image"
            :src="
              (session?.Device?.acquirer &&
                session?.Device?.Model?.imageVariants?.[
                  session?.Device?.acquirer
                ]) ||
              session?.Device?.Model?.image
            "
            max-height="60"
            max-width="60"
          >
          </v-img>
          <v-icon v-else color="primary" size="60"> mdi-cash-register </v-icon>

          <div class="d-flex flex-column lh-1 gap-1 justify-center">
            <span class="text-overline lh-1"> Reconectar POS </span>
            <h6 class="mb-0">
              {{ session?.name || session?.Address?.name }}
            </h6>
          </div>
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-tabs v-model="reconnectType" mandatory grow :show-arrows="false">
          <v-tab tab-value="same" :disabled="loadingNewSession || loading"
            >Mesmo dispositivo</v-tab
          >
          <v-tab tab-value="new" :disabled="loadingNewSession || loading"
            >Novo dispositivo</v-tab
          >

          <v-tab-item value="same">
            <div
              class="pa-6 d-flex flex-column align-center justify-center gap-2"
            >
              <template v-if="loadingNewSession">
                <v-progress-circular
                  v-if="loadingNewSession"
                  indeterminate
                  color="primary"
                  size="60"
                />
                <div class="text-center">
                  <h6 class="mb-0">Consultando...</h6>
                  <p class="mb-0">
                    Verifique se o dispositivo está exibindo o QR Code de
                    conexão
                  </p>
                </div>
              </template>
              <template v-else-if="errorNewSession">
                <v-alert type="error" class="mb-0">
                  {{ errorNewSession }}
                </v-alert>
              </template>
              <template v-else-if="newSession">
                <v-icon size="60" color="primary">mdi-check-circle</v-icon>
                <div class="text-center">
                  <h5 class="mb-0">Dispositivo encontrado</h5>
                  <p class="mb-0">O POS está pronto para reconectar</p>
                </div>
                <v-btn @click="reconnect" color="primary" :loading="loading">
                  <v-icon small left>mdi-connection</v-icon>
                  Reconectar
                </v-btn>
              </template>
              <template v-else>
                <v-icon size="60" color="error">mdi-close-circle</v-icon>
                <div class="text-center">
                  <h5 class="mb-0">Dispositivo não disponível</h5>
                  <p class="mb-0">
                    Verifique se o dispositivo está exibindo o QR Code de
                    conexão
                  </p>
                </div>
                <v-btn text @click="searchSameDevice" class="mt-2" x-small>
                  <v-icon small left>mdi-refresh</v-icon>
                  Tentar novamente
                </v-btn>
              </template>
            </div>
          </v-tab-item>
          <v-tab-item value="new">
            <div
              class="pa-6 d-flex flex-column align-center justify-center gap-2"
            >
              <pos-search v-model="newSession" />

              <v-btn
                @click="reconnect"
                color="primary"
                :loading="loading"
                :disabled="!newSession"
              >
                <v-icon small left>mdi-connection</v-icon>
                Reconectar
              </v-btn>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions class="d-flex align-end gap-1 justify-center">
        <v-btn text :disabled="loading" @click="close"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import POS from "@/services/admin/pos";
import PosSearch from "./PosSearch.vue";

export default {
  components: {
    PosSearch,
  },
  data: () => ({
    isOpen: false,
    loading: false,
    error: false,
    session: null,
    newSession: null,
    loadingNewSession: false,
    errorNewSession: false,
    reconnectType: "same",
  }),

  methods: {
    open(session) {
      this.isOpen = true;
      this.loading = false;
      this.loadingNewSession = false;
      this.errorNewSession = false;
      this.newSession = null;
      this.error = false;
      this.session = session;
      this.reconnectType = "same";
      this.searchSameDevice();
    },
    close() {
      if (this.loading) return;
      this.isOpen = false;
      this.loading = false;
      this.error = false;
      this.session = null;
    },
    async searchSameDevice() {
      try {
        if (this.loadingNewSession) return;
        this.loadingNewSession = true;
        const { sessions } = await POS.adopt.searchSN(
          this.selectedOrganization.id,
          this.session.Device.serialNumber
        );

        this.newSession = sessions[0];
      } catch (error) {
        console.log(error);
        this.errorNewSession = error.message;
      } finally {
        this.loadingNewSession = false;
      }
    },
    async reconnect() {
      try {
        this.loading = true;
        const response = await POS.adopt.reconnect(
          this.selectedOrganization.id,
          this.session.id,
          {
            code: this.newSession.code,
          }
        );
        this.loading = false;
        this.close();
        this.$emit("success");
      } catch (error) {
        console.log(error);
        this.error = error.message || "Erro ao reconectar";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["config"]),
  },
  watch: {
    reconnectType(val) {
      if (val === "same" && this.session) this.searchSameDevice();
      else this.newSession = null;
    },
  },
  mounted() {
    this.$parent.$on("reconnect-pos-modal", this.open);
  },
  props: {},
  created() {},
};
</script>

<style></style>
